module.exports = __webpack_public_path__ + "img/typhoon_cover.671ec60c.png";